import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/** Calm admin page chrome — plan/27 + plan/35 type hierarchy. */
export function PageHeader(props: {
  title: string;
  description?: string;
  /** Quiet context above the title (doc number, section). Not all-caps micro-chrome. */
  eyebrow?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex w-full flex-wrap items-end justify-between gap-4 animate-[fadeIn_220ms_ease-out]",
        props.className,
      )}
    >
      <div className="min-w-0">
        {props.eyebrow ? (
          <div className="mb-1.5 text-sm text-[var(--color-muted)]">
            {props.eyebrow}
          </div>
        ) : null}
        <h1
          className="m-0 font-[family-name:var(--font-display)] font-semibold leading-tight tracking-tight text-[var(--color-foreground)] sm:text-[2rem]"
          style={{ fontSize: "var(--desk-title-size)" }}
        >
          {props.title}
        </h1>
        {props.description ? (
          <p className="mt-2 max-w-xl text-[0.9375rem] leading-relaxed text-[var(--color-muted)]">
            {props.description}
          </p>
        ) : null}
      </div>
      {props.actions ? (
        <div className="flex flex-wrap items-center gap-2">{props.actions}</div>
      ) : null}
    </div>
  );
}
